<template>
    <div>
        <b-container style="margin-top:25px;margin-bottom:25px">
            <b-card no-body class="text-center bg-secondary text-light">
                <br />
                <h2>SU DISEÑO FUE ENVIADO</h2>
                <hr />
                <div>
                    <p class="text-xl-left">
                        No venga a buscar su pedido si aun no ha recibido nuestra confirmacion via mail.
                        Si en el transcurso de las proximas 24 hs habiles no recibe respuesta en su casilla de correo llamenos por telefono.
                        <br />Una vez confirmada la recepcion pueden venir en cualquier momento a buscar su trabajo que sera impreso una vez que se presente en nuestro local.
                    </p>
                    <div class="row">
                        <div class="col-4">
                            <h5>Nro.Pedido : {{getidPedido}}</h5>
                        </div>
                        <div class="col-4">
                            <h5>Cantidad : {{setCantidad}}</h5>
                        </div>
                        <div class="col-4">
                            <h5>Precio: {{GetPrecio}}</h5>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-3"></div>
                        <div class="col-6">
                            <h3>
                                Muchas Gracias,
                                <br />Openticket
                            </h3>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <br />
            </b-card>
        </b-container>
    </div>
</template>
<script>
    export default {
        name: "Envio",
        props: ["getidPedido", "setCantidad", "GetPrecio"],
    }
</script>
 